import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
var CloseConfirmationModal = function CloseConfirmationModal(_ref) {
  var isEditMode = _ref.isEditMode,
    onConfirm = _ref.onConfirm,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: isEditMode ? t('actions_quit_editing_badge_image') : t('actions_quit_creating_badge_image'),
    body: isEditMode ? t('modal_confirm_quit_edit_without_save') : t('modal_confirm_quit_creation_without_save'),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose
    }, {
      label: t('actions_confirm'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onClose
  });
};
export default CloseConfirmationModal;